/** The user-service getters the location-dropdown request payload is built from. */
export interface LocationDropdownUser {
  /** Customer id of the signed-in user. */
  getCustomerId(): number;
  /** Id of the signed-in user. */
  getUserId(): number;
  /** Role code of the signed-in user. */
  getRole(): string;
  /** Whether the signed-in user is a department head. */
  getIsHead(): boolean;
}

/** Request payload of the compliance location-dropdown endpoints. */
export interface LocationDropdownParams {
  customer_id: number;
  user_id: number;
  /** Role the tree is scoped to. */
  role: string;
  /** `'S'` / `'I'` (or the raw stored value when it is neither). */
  is_statutory_or_internal: string;
  is_head: boolean;
}

/**
 * Builds the payload of the location-dropdown endpoints: the signed-in user's ids and head flag,
 * the dashboard's current compliance type (the dashboard filter stores the full word in
 * `sessionStorage['complianceType']`, the endpoints expect `'S'` / `'I'`) and the role to scope to.
 * @param user - The user service.
 * @param role - Role to scope the tree to; defaults to the user's own role.
 * @returns The request payload.
 */
export function buildLocationDropdownParams(user: LocationDropdownUser, role: string = user.getRole()): LocationDropdownParams {
  const complianceTypeRaw = sessionStorage.getItem('complianceType') || 'Statutory';
  const complianceType = complianceTypeRaw === 'Statutory' ? 'S' : complianceTypeRaw === 'Internal' ? 'I' : complianceTypeRaw;
  return {
    customer_id: user.getCustomerId(),
    user_id: user.getUserId(),
    role,
    is_statutory_or_internal: complianceType,
    is_head: user.getIsHead(),
  };
}
